module.exports = __webpack_public_path__ + "static/img/oulebi.66f5b76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/oulebi.jpg
// module id = EZvP
// module chunks = 0